export default {
    userInfo: null,
    msgDialog: null,
    pwdDialog: false,
    enterpriseList: [],
    msgUnreadNum: 0,
    isNewYear: false,
    isNational: false, // 是否国庆皮肤
    isSpring: false, // 是否龙年皮肤
    themeItem:null
}
